(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();

/* ------------------------------------------------------------------
   Musterbox: maximal 1 Stück pro Bestellung
   - blendet im Warenkorb (Seite + Drawer) die Mengen-Buttons der
     Musterbox aus
   - korrigiert den Warenkorb, falls trotzdem mehr als 1 Musterbox
     (auch DE + EN zusammen) drin liegt
   Footer.js wird auf jeder Seite geladen, deshalb liegt es hier.
------------------------------------------------------------------- */
(function () {
	const HANDLE = 'musterbox';
	const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	let busy = false;

	const isMusterboxRow = (row) =>
		!!row.querySelector('a[href*="/products/' + HANDLE + '"]');

	const lockQuantityInputs = () => {
		document.querySelectorAll('.cart-item').forEach((row) => {
			if (!isMusterboxRow(row)) return;
			row.querySelectorAll('quantity-input .quantity__button, quantity-input button').forEach((btn) => {
				btn.style.display = 'none';
			});
			row.querySelectorAll('quantity-input input').forEach((input) => {
				input.readOnly = true;
				input.max = 1;
			});
		});
	};

	const enforceLimit = () => {
		if (busy) return;
		busy = true;
		fetch(root + 'cart.js', { credentials: 'same-origin' })
			.then((r) => r.json())
			.then((cart) => {
				const updates = {};
				let counted = 0;
				let changed = false;
				cart.items.forEach((item) => {
					if (item.handle !== HANDLE) return;
					const allowed = Math.max(0, 1 - counted);
					if (item.quantity > allowed) {
						updates[item.key] = allowed;
						changed = true;
					}
					counted += Math.min(item.quantity, allowed);
				});
				if (!changed) {
					busy = false;
					return;
				}
				return fetch(root + 'cart/update.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({ updates: updates }),
				}).then((r) => {
					// Nur einmal neu laden, um Endlosschleifen zu vermeiden
					let last = 0;
					try { last = Number(sessionStorage.getItem('mb-limit-reload') || 0); } catch (e) {}
					if (r.ok && Date.now() - last > 5000) {
						try { sessionStorage.setItem('mb-limit-reload', String(Date.now())); } catch (e) {}
						window.location.reload();
					} else {
						busy = false;
					}
				});
			})
			.catch(() => {
				busy = false;
			});
	};

	const init = () => {
		lockQuantityInputs();
		enforceLimit();

		let timer;
		new MutationObserver(() => {
			clearTimeout(timer);
			timer = setTimeout(lockQuantityInputs, 50);
		}).observe(document.body, { childList: true, subtree: true });

		if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(enforceLimit, 300));
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
